// extracted by mini-css-extract-plugin
export var boxItems = "_1m-1";
export var button = "_1m-5";
export var filterGroupBox = "_1m-0";
export var icon = "_1m-2";
export var iconSecondary = "_1m-4";
export var iconWrapper = "_1m-3";